import PropTypes from 'prop-types';
import { Component } from 'react';
import DisplayAdsProvider from '../providers/DisplayAdsProvider';
import LocationAndLocalizationProvider from '../providers/LocationAndLocalizationProvider';
import { RoutePropsProvider } from '../providers/RoutePropsProvider';

export default function withContextProviders(TargetComponent) {
  class ComponentWithContextProviders extends Component {
    static propTypes = {
      locale: PropTypes.string.isRequired,
      localizations: PropTypes.object.isRequired,
      location: PropTypes.object.isRequired,
      route: PropTypes.object.isRequired,
    };

    render() {
      /* eslint-disable no-unused-vars,comma-dangle */
      const { locale, localizations, location, ...other } = this.props;
      /* eslint-enable no-unused-vars,comma-dangle */

      return (
        <RoutePropsProvider routes={other.route.routes}>
          <LocationAndLocalizationProvider
            locale={locale}
            location={location}
            localizations={localizations}
          >
            <DisplayAdsProvider locale={locale}>
              <TargetComponent
                locale={locale}
                location={location}
                localizations={localizations}
                {...other}
              />
            </DisplayAdsProvider>
          </LocationAndLocalizationProvider>
        </RoutePropsProvider>
      );
    }
  }

  return ComponentWithContextProviders;
}
